import postHeroView from './postHeroComponent.html';
import './postHeroComponent.css';

export function postHeroComponent() {
	return {
		bindings: {
			post: '=',
		},
		controllerAs: 'vm',
		controller: postHeroComponentCtrl,
		template: postHeroView,
	};
}

export class postHeroComponentCtrl {
	constructor(Post) {
		'ngInject';
		this.Post = Post;
	}

	viewFullscreen() {
		this.Post.viewFullscreen(this.post);
	}
}
